/** @format */

import { END_POINT } from "utils";
import { deleteRequest, getRequest, patchRequest, postRequest } from "./axios";
import type { WmsCode } from "types";

let cachedWmsCodes: WmsCode[] | null = null;
let inflight: Promise<WmsCode[]> | null = null;

export const wmsCodeService = {
  list: async (): Promise<WmsCode[]> => {
    if (cachedWmsCodes) return cachedWmsCodes;
    if (inflight) return inflight;

    inflight = getRequest(END_POINT.WMS_CODES.LIST)
      .then((rs) => rs.data?.data ?? rs.data ?? [])
      .catch(() => [])
      .finally(() => {
        inflight = null;
      });

    cachedWmsCodes = await inflight;
    return cachedWmsCodes;
  },
  create: async (payload: WmsCode) => {
    const rs = await postRequest(END_POINT.WMS_CODES.LIST, payload);
    cachedWmsCodes = null;
    return rs.data;
  },
  update: async (id: number | string, payload: WmsCode) => {
    const rs = await patchRequest(`${END_POINT.WMS_CODES.LIST}/${id}`, payload);
    cachedWmsCodes = null;
    return rs.data;
  },
  destroy: async (id: number | string) => {
    const rs = await deleteRequest(`${END_POINT.WMS_CODES.LIST}/${id}`);
    cachedWmsCodes = null;
    return rs.data;
  },
};
